module.exports = __webpack_public_path__ + "img/assault1.b8f9c29c.png";